const Separator = (props) => {
  return (
    <div style={{ minHeight: 60, display: "flex", alignItems: "center" }}>
      <h2 className="text-primary">{props.title}</h2>
    </div>
  );
};

export default Separator;
